import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PaletteIcon(props: IconProps) {
    return <Icon {...props} iconKey={"palette"}/>
}
